'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import { FormikHelpers } from 'formik'

/* -----------------------------------------------------------------------------
 * submitForm
 * -------------------------------------------------------------------------- */

const submitForm =
  submitFn =>
  <Values extends { [k: string]: any }>(
    values: Values,
    actions: FormikHelpers<Values>
  ) => {
    const { setErrors, setStatus } = actions
    setStatus(undefined)

    return submitFn(values, actions).catch(error => {
      if (!error.res) {
        setStatus({
          type: 'error',
          msg: "Uh Oh! Looks like you aren't connected to the internet. Please check your connection and try again."
        })
      } else if (error.res && error.res.code && error.res.code === 429) {
        setStatus({
          type: 'error',
          msg: 'Too many failed attempts. Please try again later.'
        })
      } else if (!error.res.body.field_errors) {
        setStatus({ type: 'error', msg: error.message })
      } else {
        setErrors(error.res.body.field_errors)
      }
    })
  }

export default submitForm
